import { useContext } from 'react';

import AuthContext from '../../AuthContext';

const useAuth = () => {
  const {
    logout,
    login,
    memberDetails,
    isMemberDetailsReady,
    syncMemberDetails,
  } = useContext(AuthContext);

  return {
    logout,
    login,
    memberDetails,
    isMemberDetailsReady,
    syncMemberDetails,
  };
};

export default useAuth;
